import React  from 'react'
import DropDown from '../dropdown';
import PropTypes from "prop-types";
import { Rooms } from '../../../api/services/next';

const RoomsDropDown = ({...rest}) => {

    return <DropDown search api={Rooms.GetRooms} textField="Name" descriptionField="Number" valueField="Id" {...rest}/>
}

RoomsDropDown.propTypes = {
    roomTypes: PropTypes.any,
    HotelID: PropTypes.any
}
export default RoomsDropDown
